import { Grid, Typography } from '@mui/material';
import { useApp } from '../../Contexts/AppProvider';

const Footer: React.FC = () => {
  const {config} = useApp();
  
  return (
    <Grid container spacing={0}>
      <Grid item xl={6} lg={6} md={6} xs={12} style={{display: 'flex', justifyContent: 'center'}}>
        <Typography variant='caption' color='#009fff' sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>Copyright © {new Date().getFullYear()}. n², Tecnologia e Informação LTDA. Todos os direitos reservados.</Typography>
      </Grid>

      <Grid item xl={6} lg={6} md={6} xs={12} sx={{textAlign: 'right'}}>
        <img style={{position: 'relative', height: 60}} src={`${config?.assets?.poweredby}`} alt='poewred' />
      </Grid>
    </Grid>
  );
}

export default Footer;